import { jsx as o, jsxs as m } from "react/jsx-runtime";
import { Checkbox as ct } from "./index.es31.js";
import { Thumbnail as mt } from "./index.es126.js";
import { BodyText as q } from "./index.es505.js";
import { Heading as lt } from "./index.es507.js";
import c from "classnames";
import { useState as G, useRef as pt, useEffect as ft, useCallback as p } from "react";
import { MenuItemWrapper as ht } from "./index.es5541.js";
import { PoiDetailsItemActions as ut } from "./index.es5542.js";
import t from "./index.es5543.js";
import { tooltipIconPropsConvertor as xt } from "./index.es5536.js";
import { Box as vt } from "./index.es519.js";
import { Badge as It } from "./index.es7.js";
import { TooltipIcon as Nt } from "./index.es162.js";
import { useScreenZoom as dt } from "./index.es589.js";
import { onKeyDownEnterAndSpace as Ct } from "./index.es526.js";
import { Bullets as Wt } from "./index.es515.js";
import { SimpleTooltip as gt } from "./index.es127.js";
const Gt = ({
  label: s,
  address: v,
  bullets: J,
  hasCheckbox: I,
  thumbnail: D,
  isSelected: E,
  testId: N,
  badge: H,
  disabled: e,
  infoTooltip: Q,
  tooltipIconProps: U,
  CTATooltip: $,
  tooltip: X,
  isAnimated: f = !0,
  headerElement: Y = "span",
  isViewMode: i = !1,
  onMouseLeave: k,
  onMouseEnter: B,
  onClick: h,
  CTAProps: n,
  visits: y,
  metricsValue: z,
  onSelect: d,
  isCategory: _ = !1,
  ...b
}) => {
  var S, T;
  const [l, O] = G(!1), [M, F] = G(!1), { zoomPercentage: w } = dt(), u = pt(null), r = w >= 200, C = (n == null ? void 0 : n.onClick) || (n == null ? void 0 : n.items) || (n == null ? void 0 : n.text), A = ((S = u.current) == null ? void 0 : S.clientWidth) === 360, j = (((T = u.current) == null ? void 0 : T.clientWidth) || 0) < 560, K = xt({
    tooltipIconProps: U,
    labelInfo: Q
  }), L = z || y;
  ft(() => {
    i || O(!f);
  }, [f, i]);
  const x = p(
    (a, st, g) => {
      !e && f && !i && (g == null || g(st), O(a));
    },
    [e, f, i]
  ), R = p(
    (a) => x(!0, a, B),
    [x, B]
  ), Z = p(
    (a) => x(!1, a, k),
    [x, k]
  ), V = c(t.poiItem, {
    [t.poiItemDisabled]: e,
    [t.poiItemViewMode]: i
  }), P = c(t.poiContent), tt = c(t.poiDetails, {
    [t.poiDetailsWithCheckbox]: E || I && l,
    [t.poiDetailsNoCheckbox]: !I || e
  }), et = c(t.poiTextContainer, {
    [t.poiTextContainerWithCTA]: C && l && j && !r,
    [t.poiTextContainerWithViewCTA]: M || A && i && !r,
    [t.poiTextContainerWithCTAZoomed]: C && l && j && r
  }), ot = c(t.poiHeader, {
    [t.poiHeaderFixed]: !r
  }), it = c(t.poiInfo, {
    [t.poiInfoFixed]: !r
  }), nt = c(t.poiCTA, {
    [t.poiCTAVisible]: l || i,
    [t.poiCTAViewMode]: i,
    [t.poiCTAWrapping]: l && r
  }), W = e ? "disabled" : "primary", rt = p(
    (a) => {
      !(e || i) && document.activeElement === u.current && Ct(a, d);
    },
    [e, i, d]
  ), at = p(
    (a) => {
      e || i || h == null || h(a);
    },
    [e, i, h]
  );
  return /* @__PURE__ */ o(ht, { tooltip: X, testId: N + "-tooltip" || `${s}-item-tooltip`, children: /* @__PURE__ */ m(
    vt,
    {
      ref: u,
      role: "menuitem",
      className: V,
      "data-testid": N,
      tabIndex: 0,
      onMouseOver: R,
      onFocus: R,
      onMouseLeave: Z,
      onBlur: Z,
      "aria-disabled": e,
      onClick: at,
      onKeyDown: rt,
      "aria-label": s || "poi-detail-item",
      highlightOnHover: !0,
      ...b,
      children: [
        /* @__PURE__ */ m("div", { className: P, children: [
          I && /* @__PURE__ */ o("div", { className: t.poiCheckbox, children: /* @__PURE__ */ o(
            ct,
            {
              id: `${s}-checkbox`,
              checked: E,
              disabled: e,
              "aria-label": `${s} checkbox`,
              onCheckedChange: d
            }
          ) }),
          /* @__PURE__ */ m("div", { className: tt, children: [
            D && /* @__PURE__ */ o(
              mt,
              {
                hasBackground: _,
                src: D,
                size: "extra-large",
                disabled: e
              }
            ),
            /* @__PURE__ */ m("div", { className: et, children: [
              /* @__PURE__ */ m("div", { className: it, children: [
                /* @__PURE__ */ m("div", { className: ot, children: [
                  /* @__PURE__ */ o(
                    lt,
                    {
                      isEllipsis: !r,
                      variant: "h5",
                      element: Y,
                      color: W,
                      children: s
                    }
                  ),
                  H && /* @__PURE__ */ o(It, { label: H }),
                  K && /* @__PURE__ */ o(
                    "div",
                    {
                      className: t.poiInfoIcon,
                      "aria-label": "extra information",
                      role: "status",
                      "data-testId": `${N}-tooltip-icon-wrapper`,
                      children: /* @__PURE__ */ o(Nt, { ...K })
                    }
                  )
                ] }),
                v && /* @__PURE__ */ o(
                  q,
                  {
                    isEllipsis: !r,
                    size: "small",
                    color: W,
                    "aria-label": `${s} address:${v}`,
                    testId: "poi-details-item-address",
                    children: v
                  }
                ),
                L && /* @__PURE__ */ o(
                  q,
                  {
                    isEllipsis: !r,
                    size: "small",
                    variant: "semi-bold",
                    color: W,
                    element: "p",
                    "aria-label": `${s} ${z || "visits:" + y}`,
                    testId: "poi-details-item-metrics",
                    children: L
                  }
                )
              ] }),
              /* @__PURE__ */ o(Wt, { bullets: J, disabled: e })
            ] })
          ] })
        ] }),
        C && /* @__PURE__ */ o(gt, { title: $, isActive: !!$, children: /* @__PURE__ */ o(
          "span",
          {
            className: nt,
            onMouseEnter: () => F(!0),
            onMouseLeave: () => F(!1),
            children: /* @__PURE__ */ o(
              ut,
              {
                isViewMode: i,
                disabled: e,
                ...n
              }
            )
          }
        ) })
      ]
    }
  ) });
};
export {
  Gt as POIDetailsItem
};
//# sourceMappingURL=index.es86.js.map
